<div class="modal fade" [class.in]="isShown" [ngStyle]="{'z-index': zIndex + 1}">
    <div class="modal-dialog" [ngClass]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" *ngIf="options?.allowClose" class="close" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <div class="modal-body">
                <div [froalaView]="message"></div>
            </div>
            <div class="modal-footer">
        <span *ngFor="let btn of buttons">
          <button type="button" class="btn btn-primary text-uppercase" style="min-width: 90px"
                  (click)="onButtonClick(btn)">{{btn.text}}</button>
        </span>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" [class.in]="isShown" *ngIf="isShown" [ngStyle]="{'z-index': zIndex}"></div>
